/**
 * Auth-related string constants shared across the auth feature.
 * Keep message strings here so they are easy to update in one place.
 */

/** Response message returned by any BFF endpoint when the user's session
 *  has been invalidated server-side. Detected by the Axios response
 *  interceptor to show the SessionExpired modal in MainLayoutScreen. */
export const SESSION_EXPIRED_MSG =
  'Your session has expired. Please sign in again to continue.';

/** statusFlag value returned by the shift status indicator API when the
 *  technician is not currently in a shift. Any protected action (indirect
 *  activity, begin/resume repair, new WO, new repair, tab switching) must
 *  first verify this flag and block with the session-expired modal if true. */
export const SHIFT_INACTIVE_STATUS_FLAG = 2;